import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BodyPipeline() {
    return (
        <OnboardingBody
            title={
                <span>
                    Leads move through <em>stages</em> of a <em>pipeline</em>
                </span>
            }
        >
            <div>
                <p>
                    We’ll help you customize your stages or create multiple pipelines. You can tune
                    a pipeline for any workflow, whether it’s outbound sales, account management, or
                    recruiting.
                </p>
            </div>
        </OnboardingBody>
    );
}
